import request from "@/utils/request.js"
// 获取服务介绍
export function get_contact_us_service(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_contact_us_service',
		params: data
	})
}
// 国内服务网点 - 选择省
export function get_int_select(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_int_select',
		params: data
	})
}
// 获取国内服务网点
export function get_int_service_network(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_int_service_network',
		params: data
	})
}
// 获取国际服务网点 - 选择国家
export function get_abroad_select(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_abroad_select',
		params: data
	})
}
// 获取国际服务网点
export function get_abroad_service_network(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_abroad_service_network',
		params: data
	})
}
// 服务优势
export function service_advantages(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/service_advantages',
		params: data
	})
}
// 常见反馈
export function get_question(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_question',
		params: data
	})
}
// 查询总部信息
export function get_headquarters(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_headquarters',
		params: data
	})
}
// 查询Email
export function get_en_contact_us_service(data) {
	return request({
		method: 'GET',
		url: '/ContactUs/get_en_contact_us_service',
		params: data
	})
}

// 联系我们-提交表单
export function sub_message(data) {
	return request({
		method: 'POST',
		url: '/aohua.contactus/sub_message',
		data
	})
}